import { Lang, translate } from '../components/Locale'

export let prevent_auto_complete_as_password = <input type="password" hidden />

export function validatePassword(lang: Lang, password: string): string | null {
  if (password.length < 6) {
    return translate(lang, {
      en: 'Password must be at least 6 characters long',
      zh_cn: '密码必须至少6个字符长',
      zh_hk: '密碼必須至少6個字符長',
    })
  }
  return null
}
